import { j as o } from "./index.es33.js";
import { icons as i } from "./index.es145.js";
import { Icon as e } from "./index.es7.js";
import r from "./index.es146.js";
var a = function a(_ref) {
  var n = _ref.size,
    s = _ref.color;
  return o.jsx("div", {
    className: r.spinnerWrapper,
    children: o.jsx(e, {
      className: r.spinnerIcon,
      icon: i.outline.loading,
      size: n,
      color: s
    })
  });
};
export { a as Spinner };